(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sts-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sts-hero-carousel')) {
  customElements.define('sts-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.querySelector('[data-prev]')?.addEventListener('click', () => { this.show(this.index - 1); this.restart(); }, options);
      this.querySelector('[data-next]')?.addEventListener('click', () => { this.show(this.index + 1); this.restart(); }, options);
      this.querySelector('[data-pause]')?.addEventListener('click', () => { this.paused = !this.paused; this.button(); this.restart(); }, options);
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.restart(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.restart(); }, 0), options);
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.restart(), options);
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-slide]');
        if (slide && this.slides.includes(slide)) { this.show(this.slides.indexOf(slide)); this.paused = true; this.button(); this.stop(); }
      }, options);
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) { this.paused = true; this.button(); this.stop(); } }, options);
      this.button();
      this.restart();
    }
    disconnectedCallback() { this.stop(); this.abort?.abort(); }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      const counter = this.querySelector('[data-counter]');
      if (counter) counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    button() {
      const button = this.querySelector('[data-pause]');
      if (button) button.textContent = this.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    }
    stop() { clearInterval(this.timer); }
    restart() {
      this.stop();
      if (!this.paused && this.slides.length > 1 && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) {
        this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
